var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrinkMxrLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffe54b",
    id: "svg_1",
    points: "19.361 19 44.639 19 32 32.213 19.361 19",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#ffffff",
    fill: "none",
    id: "svg_2",
    points: "44.11095526814461,60 20.110955268144608,60 30.110955268144608,53 34.11095526814461,53 44.11095526814461,60 ",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#ffffff",
    fill: "none",
    id: "svg_3",
    points: "54 15 10 15 30 35.909 30 53 34 53 34 35.909 54 15",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe54b",
    id: "svg_4",
    d: "m55.5355,11.4645a5,5 0 0 0 -8.5355,3.5355l10,0a4.984,4.984 0 0 0 -1.4645,-3.5355z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#ffffff",
    fill: "none",
    id: "svg_5",
    d: "m60,15a7.9751,7.9751 0 0 0 -2.3431,-5.6569l-5.6569,5.6569l8,0z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#ffffff",
    fill: "none",
    id: "svg_6",
    d: "m52,15l-5.6569,-5.6569a7.9751,7.9751 0 0 0 -2.3431,5.6569l8,0z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#ffffff",
    fill: "none",
    id: "svg_7",
    points: "11 4 20 4 32 15",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#ffffff",
    fill: "none",
    id: "svg_8",
    d: "m46.3431,9.3431l5.6569,5.6569l0,-8a7.9751,7.9751 0 0 0 -5.6569,2.3431z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#ffffff",
    fill: "none",
    id: "svg_9",
    d: "m52,7l0,8l5.6569,-5.6569a7.9751,7.9751 0 0 0 -5.6569,-2.3431z",
    className: "cls-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkMxrLogo);
export default __webpack_public_path__ + "static/media/DrinkMXRLogo.4994f7004944361bd4b8c82d84e7240e.svg";
export { ForwardRef as ReactComponent };